import * as React from "react";
import OutlineLikeEngageButton, {
  IProps as IBaseProps,
} from "../outlineLikeEngageButton";

interface IProps extends IBaseProps {
  postId: Vingle.Id;
}

const PostLikeButton: React.FC<IProps> = props => (
  <OutlineLikeEngageButton {...props} />
);

export default PostLikeButton;
